<template>
	<div class="product-listing">
		<BlockProductListingTop/>
		<div class="container">
			<div v-if="products" class="row item-block__row">
				<template v-for="(product, index) in products">
					<PartProduct :product="product" :key="index"/>
				</template>
			</div>
			<PartPagination
				:pagination="pagination"
			/>
		</div>
	</div>
</template>

<script>
import BlockProductListingTop from '../blocks/BlockProductListingTop.vue';
import PartProduct from '../parts/PartProduct.vue';
import PartPagination from '../parts/PartPagination.vue';

export default {
	props: ['products', 'pagination'],
	components: {
		BlockProductListingTop,
		PartProduct,
		PartPagination
	},

};
</script>

<style lang="scss" scoped>
.product-listing {
	padding-bottom: 88px;

	@include mq($lg) {
		padding-bottom: 50px;
	}

	@include mq($md) {
		padding-bottom: 40px;
	}

	@include mq($sm) {
		padding-bottom: 30px;
	}
}

.item-block__row {
	margin: 0 -20px;

	@include mq($xl) {
		margin: 0 -15px;
	}
}
</style>
